module.exports = __webpack_public_path__ + "img/20191011165310322.9973ad15.jpg";